
    import { css } from 'lit-element';
    export default css`:host{--label-display:var(--kat-input-label-display,block);--label-outlay:var(--kat-input-label-outlay,0.3rem)}kat-label{display:var(--label-display);padding-bottom:var(--label-outlay)}.metadata kat-label{--label-outlay:0;display:block}.metadata kat-label:first-of-type{padding-top:.3rem}`;
  